
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.369","height":"10.928"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.928 10.171V6.2H.729a.729.729 0 1 1 0-1.457h4.2V.758a.758.758 0 1 1 1.516 0v3.981h4.2a.729.729 0 0 1 0 1.457h-4.2v3.975a.758.758 0 1 1-1.516 0z","data-name":"Union 64","fill":"#444"}})])
          )
        }
      }
    